module.exports = __webpack_public_path__ + "img/anna.0d965bdc.png";